import cn from 'classnames';
import Checkbox from '../audi-ui-components/Checkbox';
import _pull from 'lodash/pull';

const CheckboxGroup = ({
    name,
    label,
    className,
    labelClassName = "mb-2",
    checkboxClassName = "d-block mb-3",
    theme,
    value,
    options,
    delimeter,
    isInvalid,
    invalidMessage,
    onChange = ()=>{},
    onBlur = ()=>{},
}) => {

    var checks = [];
    if (value) {
        if (delimeter) {
            checks = value.split(delimeter);
        } else {
            checks = value;
        }
    }
    return (
        <div className={cn("checkbox-group", className)}>
            {label && <p className={cn(labelClassName)}>{label}</p>}
            <div>
                {options && options.map((opt, i) => {
                    let isChecked = checks.indexOf(opt.value) > -1;
                    return (
                        <Checkbox
                            key={`chk_${i}`}
                            name={name}
                            label={opt.label}
                            value={opt.value}
                            checked={isChecked}
                            onChange={() => {
                                let newValue = checks;
                                if (isChecked) {
                                    _pull(newValue, opt.value);
                                } else {
                                    newValue.push(opt.value);
                                }
                                if (delimeter) {
                                    newValue = newValue.join(delimeter);
                                }
                                onChange(newValue);
                            }}
                            onBlur={onBlur}
                            isInvalid={isInvalid}
                            className={cn(checkboxClassName)}
                            theme={theme}
                        />
                    );
                })}
            </div>
            {isInvalid && <p className="aui-textfield__error">{invalidMessage}</p>}
        </div>
    );
    
}

export default CheckboxGroup;
